import { render, staticRenderFns } from "./MPesaResultsPage.vue?vue&type=template&id=9b4a1f38&"
import script from "./MPesaResultsPage.vue?vue&type=script&lang=js&"
export * from "./MPesaResultsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports